var styles = {
  "ListItem": "pb-ListItem__ListItem",
  "listContent": "pb-ListItem__listContent",
  "listStyle": "pb-ListItem__listStyle",
  "largeMinWidth": "pb-ListItem__largeMinWidth",
  "OrderedList": "pb-ListItem__OrderedList",
  "lower-roman": "pb-ListItem__lower-roman",
  "lower-alpha": "pb-ListItem__lower-alpha",
  "-webkit-columns": "pb-ListItem__columns",
  "columns": "pb-ListItem__columns",
  "UnorderedList": "pb-ListItem__UnorderedList",
  "withIcon": "pb-ListItem__withIcon",
  "tick": "pb-ListItem__tick",
  "disc": "pb-ListItem__disc",
  "circle": "pb-ListItem__circle",
  "square": "pb-ListItem__square"
};
export default styles;